import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { AuthGate } from "./components/auth/AuthGate";
import { RequireSuperAdmin } from "./components/auth/RequireSuperAdmin";
import { AgentEditorPage } from "./pages/AgentEditorPage";
import { AgentListPage } from "./pages/AgentListPage";
import { AgentTestPage } from "./pages/AgentTestPage";
import { GuardrailsCatalogPage } from "./pages/GuardrailsCatalogPage";
import { MemoriesCatalogPage } from "./pages/MemoriesCatalogPage";
import { SkillsCatalogPage } from "./pages/SkillsCatalogPage";
import { SkillEditorPage } from "./pages/SkillEditorPage";
import { SkillNewPage } from "./pages/SkillNewPage";
import { InsightsPage } from "./pages/InsightsPage";

const authed = (el: React.ReactNode) => (
  <AuthGate>
    <RequireSuperAdmin>{el}</RequireSuperAdmin>
  </AuthGate>
);

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={authed(<AppShell />)}>
          <Route index element={<Navigate to="/agents" replace />} />
          <Route path="agents" element={<AgentListPage />} />
          <Route path="agents/new" element={<AgentEditorPage />} />
          <Route path="agents/:agentId/edit" element={<AgentEditorPage />} />
          <Route path="agents/:agentId/test" element={<AgentTestPage />} />
          <Route path="skills" element={<SkillsCatalogPage />} />
          <Route path="skills/new" element={<SkillNewPage />} />
          <Route path="skills/:skillId/edit" element={<SkillEditorPage />} />
          <Route path="memories" element={<MemoriesCatalogPage />} />
          <Route path="guardrails" element={<GuardrailsCatalogPage />} />
          <Route path="insights" element={<InsightsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/agents" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
